//App Routes Constants
export default {
	PRE_ALERT_DEVICE_SCREEN: '/alert-device',
};
